import { useOnMount } from "~/common/hooks/useOnMount";
import { trackAffiliateOnLoad } from "~/app/analytics/ga/affiliate";

export const useAffiliateTracking = () => {
  useOnMount(trackAffiliateOnLoad);
};
